import React from 'react';

const WEEKDAYS = [
  ['mon', '월'],
  ['tue', '화'],
  ['wed', '수'],
  ['thu', '목'],
  ['fri', '금'],
] as const;

const PERIODS = Array.from({ length: 6 }, (_, idx) => idx + 1);

export const WeeklyLearningGuideEmptyFrame: React.FC = () => (
  <div className="cp-disabled-actual-ui cp-weekly-learning-guide-table-wrap" aria-hidden="true">
    <table className="cp-weekly-learning-guide-table">
      <thead>
        <tr>
          <th rowSpan={2} className="cp-weekly-learning-guide-title-col">
            구분
          </th>
          {WEEKDAYS.map(([key, label]) => (
            <th key={`day-${key}`} className="cp-weekly-learning-guide-day-head">
              {label}
            </th>
          ))}
        </tr>
        <tr>
          {WEEKDAYS.map(([key], idx) => (
            <th key={`date-${key}`} className="cp-weekly-learning-guide-date-head">
              3월 {idx + 2}일
            </th>
          ))}
        </tr>
      </thead>
      {PERIODS.map((period) => (
        <tbody key={period} className="cp-weekly-learning-guide-period-tbody">
          <tr className="cp-weekly-learning-guide-tr cp-weekly-learning-guide-tr--1line">
            <th rowSpan={5} className="cp-weekly-learning-guide-period-title">
              {period}교시
            </th>
            {WEEKDAYS.map(([key]) => (
              <td key={`${period}-${key}-subject`} className="cp-weekly-learning-guide-cell cp-weekly-learning-guide-cell--center" />
            ))}
          </tr>
          <tr className="cp-weekly-learning-guide-tr cp-weekly-learning-guide-tr--1line">
            {WEEKDAYS.map(([key]) => (
              <td key={`${period}-${key}-unit`} className="cp-weekly-learning-guide-cell cp-weekly-learning-guide-cell--center" />
            ))}
          </tr>
          <tr className="cp-weekly-learning-guide-tr cp-weekly-learning-guide-tr--learning">
            {WEEKDAYS.map(([key]) => (
              <td key={`${period}-${key}-learning`} className="cp-weekly-learning-guide-cell cp-weekly-learning-guide-cell--top">
                <span className="cp-weekly-learning-guide-cell-learning-inner" />
              </td>
            ))}
          </tr>
          <tr className="cp-weekly-learning-guide-tr cp-weekly-learning-guide-tr--1line">
            {WEEKDAYS.map(([key]) => (
              <td key={`${period}-${key}-page`} className="cp-weekly-learning-guide-cell cp-weekly-learning-guide-cell--center" />
            ))}
          </tr>
          <tr className="cp-weekly-learning-guide-tr cp-weekly-learning-guide-tr--1line">
            {WEEKDAYS.map(([key]) => (
              <td key={`${period}-${key}-material`} className="cp-weekly-learning-guide-cell cp-weekly-learning-guide-cell--center" />
            ))}
          </tr>
        </tbody>
      ))}
      <tbody className="cp-weekly-learning-guide-notice-tbody">
        <tr>
          <th className="cp-weekly-learning-guide-period-title cp-weekly-learning-guide-period-title--notice">가정통신문</th>
          <td colSpan={WEEKDAYS.length} className="cp-weekly-learning-guide-notice-cell">
            <div className="cp-weekly-learning-guide-notice-cell-inner" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

export const ClassRecordMemosEmptyTable: React.FC = () => (
  <div className="cp-disabled-actual-ui cp-class-record-memos-table-wrap" aria-hidden="true">
    <table className="cp-class-record-memos-table">
      <colgroup>
        <col className="cp-crm-col cp-crm-col--term" />
        <col className="cp-crm-col cp-crm-col--date" />
        <col className="cp-crm-col cp-crm-col--weekday" />
        <col className="cp-crm-col cp-crm-col--period" />
        <col className="cp-crm-col cp-crm-col--program" />
        <col className="cp-crm-col cp-crm-col--unit" />
        <col className="cp-crm-col cp-crm-col--learning" />
        <col className="cp-crm-col cp-crm-col--kind" />
        <col className="cp-crm-col cp-crm-col--note" />
      </colgroup>
      <thead>
        <tr>
          <th scope="col">학기</th>
          <th scope="col">날짜</th>
          <th scope="col">요일</th>
          <th scope="col">교시</th>
          <th scope="col">프로그램</th>
          <th scope="col">단원</th>
          <th scope="col">학습내용</th>
          <th scope="col">구분</th>
          <th scope="col">메모</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: 18 }, (_, rowIndex) => (
          <tr key={rowIndex}>
            {Array.from({ length: 9 }, (_, colIndex) => (
              <td key={colIndex} />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const ClassRecordMemosEmptyFrame: React.FC = () => (
  <div className="cp-disabled-actual-ui" aria-hidden="true">
    <article className="cp-card cp-class-record-memos-controls">
      <div className="cp-weekly-class-hours-controls cp-class-record-memos-controls-toolbar">
        <label>
          학년도
          <select value="2026" disabled aria-label="학년도 선택">
            <option value="2026">2026학년도</option>
          </select>
        </label>
        <div className="cp-class-record-memos-record-group-field">
          <span className="cp-class-record-memos-record-group-label">기록 조회 그룹</span>
          <div className="cp-apn-group-tabs cp-class-record-memos-record-group-tabs" role="tablist" aria-label="기록 멤버 그룹 범위">
            <button
              type="button"
              role="tab"
              aria-selected
              className="cp-apn-group-tab cp-class-record-memos-record-group-tab--meta is-active"
              disabled
            >
              전체 그룹 및 태그
            </button>
            <span className="cp-class-record-memos-record-group-tabs-divider" aria-hidden />
          </div>
        </div>
      </div>
    </article>
    <div className="cp-class-record-memos-layout">
      <aside className="cp-class-record-memos-sidebar" aria-label="클래스 멤버">
        <div className="cp-class-record-memos-sidebar-all">
          <h3 className="cp-class-record-memos-sidebar-title">전체조회</h3>
          <ul className="cp-class-record-memos-member-list">
            <li>
              <button type="button" className="cp-class-record-memos-member-btn is-active" disabled>
                모든 멤버 통합
              </button>
            </li>
          </ul>
        </div>
        <div className="cp-class-record-memos-sidebar-members">
          <h3 className="cp-class-record-memos-sidebar-title cp-class-record-memos-sidebar-title--per-member">멤버별 조회</h3>
          <div className="cp-class-record-memos-member-sections cp-class-record-memos-member-list--scroll">
            <section className="cp-class-record-memos-member-section" aria-label="멤버 목록">
              <h4 className="cp-class-record-memos-member-section-heading">클래스</h4>
              <ul className="cp-class-record-memos-member-list">
                {Array.from({ length: 6 }, (_, idx) => (
                  <li key={idx}>
                    <button type="button" className="cp-class-record-memos-member-btn" disabled>
                      <span className="cp-class-record-memos-member-btn-main">
                        <span className="cp-class-record-memos-member-btn-order">{String(idx + 1).padStart(2, '0')}번</span>
                        <span className="cp-class-record-memos-member-btn-name"> </span>
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            </section>
          </div>
        </div>
      </aside>
      <div className="cp-class-record-memos-main">
        <ClassRecordMemosEmptyTable />
      </div>
    </div>
  </div>
);
